import apiClient from './ApiInterceptor';

export const fetchLifeTimeValue = async (start_date, end_date, period_months) => {
    const params = {
        start_date: start_date,
        end_date: end_date,
        period_months: period_months,
    }
    const lifetime = await apiClient.get('/statistics/lifetime', {params})
    return lifetime;
};

export const fetchRetentionStat = async (start_date, end_date) => {
    const params = {
        start_date: start_date,
        end_date: end_date,
    }
    const retention = await apiClient.get('/statistics/retention', {params})
    return retention;
};

export const fetchRetentionHeatMap = async (start_date, end_date) => {
    const params = {
        start_date: start_date,
        end_date: end_date,
    }
    const retention = await apiClient.get('/statistics/retention/heat-map', {params})
    return retention;
};

export const fetchMembershipDistribution = async (start_date, end_date) => {
    const params = {
        start_date: start_date,
        end_date: end_date,
    }
    const retention = await apiClient.get('/statistics/membership-distribution', {params})
    return retention;
};
export const fetchMembershipRetention = async (start_date, end_date) => {
    const params = {
        start_date: start_date,
        end_date: end_date,
    }
    const retention = await apiClient.get('/statistics/membership-retention', {params})
    return retention;
};

export const fetchCourtesiesFunnel = async (start_date, end_date) => {
    const params = {
        start_date: start_date,
        end_date: end_date,
    }
    const retention = await apiClient.get('/statistics/courtesies/funnel', {params})
    return retention;
};

export const fetchConversionPlans = async (start_date, end_date) => {
    const params = {
        start_date: start_date,
        end_date: end_date,
    }
    const retention = await apiClient.get('/statistics/courtesies/conversion-plans', {params})
    return retention;
};

export const fetchTimeToConversion = async (start_date, end_date) => {
    const params = {
        start_date: start_date,
        end_date: end_date,
    }
    const retention = await apiClient.get('/statistics/courtesies/time-to-conversion', {params})
    return retention;
};

export const fetchCourtesyPaymentType = async (start_date, end_date) => {
    const params = {
        start_date: start_date,
        end_date: end_date,
    }
    const retention = await apiClient.get('/statistics/courtesies/payment_type', {params})
    return retention;
};
